import { Col, Row } from 'react-bootstrap';
import MembershipStatus from './MembershipStatus';
import PricingPlans from './PricingPlans';

const BillingPage = () => {
  return (
    <Row className="gy-3 mb-6 justify-content-between">
      <Col md={12} xs="auto">
        <h2 className="mb-2 text-body-emphasis">Billing</h2>
        <h5 className="text-body-tertiary fw-semibold">
          Manage your membership and subscription.
        </h5>
      </Col>

      <Col md={12}>
        <MembershipStatus />
      </Col>

      <Col md={12}>
        <h4 className="text-body-emphasis mb-1">Upgrade options</h4>
        <PricingPlans />
      </Col>
    </Row>
  );
};

export default BillingPage;
